// original script by @devmoek on GitHub
// https://github.com/devmoek/recently-viewed-section-dawn
// adapted to use section rendering api and remove jquery dependency
var __awaiter =
  (this && this.__awaiter) ||
  function (thisArg, _arguments, P, generator) {
    function adopt(value) {
      return value instanceof P
        ? value
        : new P(function (resolve) {
            resolve(value);
          });
    }
    return new (P || (P = Promise))(function (resolve, reject) {
      function fulfilled(value) {
        try {
          step(generator.next(value));
        } catch (e) {
          reject(e);
        }
      }
      function rejected(value) {
        try {
          step(generator['throw'](value));
        } catch (e) {
          reject(e);
        }
      }
      function step(result) {
        result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
      }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
  };
const rvEl = document.querySelector('.recently-viewed');
if (rvEl && rvEl instanceof HTMLElement && window.Shopify && rvEl.dataset.id) {
  const splide = new Splide(`.splide-${rvEl.dataset.id}`, {
    padding: getOffset(),
  });
  // on ready
  splide.on('ready', function () {
    if (splide.root.classList.contains('splide--hidden')) splide.root.classList.remove('splide--hidden');
  });
  splide.on('resize', function () {
    splide.options = {
      padding: getOffset(),
    };
  });
  splide.on('dragged scrolled move refresh', function () {
    const bar = splide.root.querySelector('.rv-progress-bar');
    const end = splide.Components.Controller.getEnd() + 1;
    const rate = Math.min((splide.index + 1) / end, 1);
    if (bar) bar.style.width = `${String(100 * rate)}%`;
  });
  // init splide
  splide.mount();
  setRecentlyViewedProducts();
  getRecentlyViewedProducts();
  function setRecentlyViewedProducts() {
    // get product handle from url
    const productHandle = decodeURI(window.location.pathname.split('/').slice(-1).toString());
    if (productHandle) {
      const productData = localStorage.getItem('recentlyViewed')
        ? JSON.parse(localStorage.getItem('recentlyViewed'))
        : [];
      if (Array.isArray(productData) && productData.length) {
        const maxProducts =
          rvEl instanceof HTMLElement && rvEl.dataset.maxProducts ? parseInt(rvEl.dataset.maxProducts) : 8;
        // splice current product if exists in array to be pushed again later
        if (productData.includes(productHandle)) {
          const handleIndex = productData.indexOf(productHandle);
          if (handleIndex > -1) {
            productData.splice(handleIndex, 1);
          }
        } else if (productData.length >= maxProducts) {
          productData.shift();
        }
      }
      productData.push(productHandle);
      const productDataStr = JSON.stringify(productData);
      localStorage.setItem('recentlyViewed', productDataStr);
    }
  }
  function getRecentlyViewedProducts() {
    return __awaiter(this, void 0, void 0, function* () {
      const productData = localStorage.getItem('recentlyViewed')
        ? JSON.parse(localStorage.getItem('recentlyViewed'))
        : [];
      if (Array.isArray(productData) && productData.length) {
        // use section rendering api to render product card for each handle in local storage
        for (let i = productData.length - 1; i >= 0; i--) {
          let url = `${window.Shopify.routes.root}products/${productData[i]}?section_id=card-product`;
          let res = yield fetch(url);
          if (res.ok) {
            let resText = yield res.text();
            splide.add(resText);
          } else {
            console.error(`HTTP error status ${res.status}`);
          }
        }
      }
    });
  }
  function getOffset() {
    const pageWidth = rvEl.dataset.pageWidth ? parseInt(rvEl.dataset.pageWidth) : 0;
    const minPadding = window.innerWidth > 749 ? 50 : 15;
    let offset = 0;
    if (window.innerWidth && pageWidth && minPadding) {
      offset = window.innerWidth > pageWidth ? (window.innerWidth - pageWidth) / 2 + 50 : minPadding;
    }
    return offset;
  }
}
